module.exports = __webpack_public_path__ + "android.png?14f95f96426d56a109e8366e9690d679";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android.png
// module id = 728
// module chunks = 0